import React from 'react'

import './style.css'


export default class Fonts extends React.Component {
  state = {
    italic: false,
    upper: false,
    weight: 100,
  }

  onIncrement = () => this.setState(({weight}) => ({weight: weight + 100}))
  onDecrement = () => this.setState(({weight}) => ({weight: weight - 100}))
  onUpper = () => this.setState(({upper}) => ({upper: !upper}))
  onItalic = () => this.setState(({italic}) => ({italic: !italic}))

  render() {
    const {upper, italic, weight} = this.state
    return (
      <>
        <p className="buttons">
          <button onClick={this.onDecrement}>-</button>
          <button onClick={this.onIncrement}>+</button>
          <span>{this.state.weight}</span>
          <span style={{marginLeft: 10, fontStyle: 'italic'}}>(font-weight 100 - 900)</span>
          <br/>
          <button
            onClick={this.onUpper}
          >Case {this.state.upper ? '+' : '-'}
          </button>
          <button
            onClick={this.onItalic}
          >italics {this.state.italic ? '+' : '-'}
          </button>
        </p>
        <div className="font-preview">
          {
            Array.from({length: 20}, (v, i) => <h1
              key={i}
              className={`header f${i}`}
              style={{
                fontStyle: italic ? 'italic' : 'initial',
                fontWeight: weight,
                textTransform: upper ? 'uppercase' : 'lowercase',
              } as React.CSSProperties}
            >future cloud mining</h1>
            )
          }
        </div>
      </>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Fonts/index.tsx